import { render, staticRenderFns } from "./DynamicModalEntity.vue?vue&type=template&id=deefc61c&scoped=true"
import script from "./DynamicModalEntity.vue?vue&type=script&lang=js"
export * from "./DynamicModalEntity.vue?vue&type=script&lang=js"
import style0 from "./DynamicModalEntity.vue?vue&type=style&index=0&id=deefc61c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deefc61c",
  null
  
)

export default component.exports